// extracted by mini-css-extract-plugin
export default {"rating":"TD-z","numberOfStars":"UD-z","count":"VD-z","barGraphSpacing":"WD-z","barGraph":"XD-z"};